<template>
  <div class="dropdown">
    <div class="dropdown-header" @click="toggleDropdown">
      <section-label :value="title" labelColor="#1973b8" fontSize="17px" />
      <img
        src="@/assets/img/1x/down-arrow.svg"
        class="dropdown-icon"
        :class="[dropdown && 'active']"
        alt="Dropdown"
      />
    </div>
    <transition name="toggleDropdown">
      <div class="dropdown-wrapper" v-if="dropdown">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import SectionLabel from "@/components/core/SectionLabel";
export default {
  name: "DropDown",
  components: { SectionLabel },
  props: {
    title: String,
    show: Boolean
  },
  data() {
    return { dropdown: this.show };
  },
  watch: {
    show(val) {
      this.dropdown = val;
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdown = !this.dropdown;
    }
  }
};
</script>
<style scoped>
.dropdown {
  margin-bottom: 12px;
}

.dropdown-header {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1973b8;
  cursor: pointer;
  background-color: #fff;
  border-radius: 8px;
}

.dropdown-icon {
  filter: invert(37%) sepia(50%) saturate(1121%) hue-rotate(170deg)
    brightness(94%) contrast(95%);
  max-width: 24px;
  transition: transform 200ms ease;
}

.dropdown-icon.active {
  filter: brightness(0) saturate(100%) invert(64%) sepia(17%) saturate(7472%)
    hue-rotate(321deg) brightness(101%) contrast(94%);
  transform: rotate(180deg);
}

.dropdown-wrapper {
  overflow: hidden;
  max-height: 1000px;
}

.toggleDropdown-enter-active,
.toggleDropdown-leave-active {
  transition: all 0.5s ease;
}

.toggleDropdown-enter,
.toggleDropdown-leave-to {
  max-height: 0;
}
</style>
